import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "size"];
import PropTypes from 'prop-types';
import React, { cloneElement, forwardRef } from 'react';
import styled from 'styled-components';
import { SIZES } from '../helper';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const roundSizes = {
  [SIZES.XS]: '24px',
  [SIZES.SM]: '32px',
  [SIZES.MD]: '40px',
  [SIZES.LG]: '48px',
  [SIZES.XL]: '64px'
};
const defaultRoundColor = 'var(--neutral-icon-high-emphasis)';
const defaultRoundSize = roundSizes[SIZES.MD];
const getRoundColor = _ref => {
  let {
    fill
  } = _ref;
  return fill || defaultRoundColor;
};
const getRoundSize = _ref2 => {
  let {
    size
  } = _ref2;
  return roundSizes[size] || defaultRoundSize;
};
const Root = styled.div.withConfig({
  displayName: "RoundedIcon__Root",
  componentId: "sc-xyld28-0"
})(["", " width:", ";height:", ";background-color:", ";border-radius:var(--border-radius-circle);display:flex;justify-content:center;align-items:center;"], ScopedCssBaseline, getRoundSize, getRoundSize, getRoundColor);
const RoundedIcon = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
      children,
      size
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    size: size
  }, rest), /*#__PURE__*/cloneElement(children, {
    size
  }));
});
RoundedIcon.displayName = 'RoundedIcon';
RoundedIcon.sizes = {
  [SIZES.XS]: SIZES.XS,
  [SIZES.SM]: SIZES.SM,
  [SIZES.MD]: SIZES.MD,
  [SIZES.LG]: SIZES.LG,
  [SIZES.XL]: SIZES.XL
};
RoundedIcon.defaultProps = {
  children: null,
  fill: defaultRoundColor,
  size: RoundedIcon.sizes[SIZES.MD]
};
RoundedIcon.propTypes = {
  /**
   * Should be one of *@resultadosdigitais/tangram-react-icons* like:
   * `<Cart fill={colorWhite} title="Title for this icon" />`
   */
  children: PropTypes.node,
  /**
   * Sets the RoundedIcon color
   */
  fill: PropTypes.string,
  /**
   * Sets the RoundedIcon size
   */
  size: PropTypes.oneOf([RoundedIcon.sizes[SIZES.XS], RoundedIcon.sizes[SIZES.SM], RoundedIcon.sizes[SIZES.MD], RoundedIcon.sizes[SIZES.LG], RoundedIcon.sizes[SIZES.XL]])
};
export default RoundedIcon;